module.exports = __webpack_public_path__ + "img/example-01-original.c5a9c5a8.jpg";